exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown[data-v-24c36700] {\n  max-width: 300px;\n}", ""]);

// exports
